import React, { useEffect, useState } from "react";
import { EditText, EditTextarea } from "react-edit-text";
import { useDispatch, useSelector } from "react-redux";
import { removeMtfQuestionIdFromOptions, updateMtfOption, updateSelectedComponentType } from "../../../../redux/slices/userActivity";

const maxAnswerChar = 24;

export default function SingleOption({ option, optionKey, style }) {
  const { userActivities, selectedUserActivity } = useSelector((state) => state.userActivity);
  const { modalOpen: previewModalOpen } = useSelector((state) => state.preview);

  const dispatch = useDispatch();
  const [hoverLeft, setHoverLeft] = useState(false);
  const [hoverRight, setHoverRight] = useState(false);

  useEffect(() => {
    dispatch(
      removeMtfQuestionIdFromOptions({
        selectedActivityIdx: selectedUserActivity,
      })
    );
  }, []);

  useEffect(() => {
    const { l_image, l_image_url, r_image, r_image_url } = option;
    if (l_image !== null) {
      if (l_image_url !== null) return;
      let image_url = { l_image_url: l_image };
      dispatch(updateMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: option.id, updatedOption: image_url }));
    }
    if (l_image_url !== null) {
      if (l_image !== null) return;
      let image_url = { l_image: l_image_url };
      dispatch(updateMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: option.id, updatedOption: image_url }));
    }
    if (r_image !== null) {
      if (r_image_url !== null) return;
      let image_url = { r_image_url: r_image };
      dispatch(updateMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: option.id, updatedOption: image_url }));
    }
    if (r_image_url !== null) {
      if (r_image !== null) return;
      let image_url = { r_image: r_image_url };
      dispatch(updateMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: option.id, updatedOption: image_url }));
    }
  }, []);

  const handleChange = (e) => {
    // console.log(e.target.value);
    if (optionKey === "l_option") {
      dispatch(updateMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: option.id, updatedOption: { l_option: e.target.value } }));
    }
    if (optionKey === "r_option") {
      dispatch(updateMtfOption({ selectedActivityIdx: selectedUserActivity, selectedOptionIdx: option.id, updatedOption: { r_option: e.target.value } }));
    }
  };

  const handleButtonClick = () => {
    dispatch(
      updateSelectedComponentType({
        type: "button",
        name: "button",
        hoverName: "optionHover",
      })
    );
  };

  const handleTextClick = () => {
    // setTimeout(() => {
    //   const inputField = document.querySelector("#mtf-right-option-input");
    //   inputField.select();
    // }, 100);
    dispatch(
      updateSelectedComponentType({
        type: "text",
        name: "option",
      })
    );
  };

  if (optionKey === "l_option")
    return (
      <button
        onMouseEnter={() => setHoverLeft(true)}
        onMouseLeave={() => setHoverLeft(false)}
        className="@button activity_container__mtf_btn"
        style={{ ...style.button, ...(hoverLeft ? style.optionHover : null) }}
        onClick={handleButtonClick}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleTextClick();
          }}
        >
          <EditText
            value={option.l_option}
            className="editable_text"
            style={{ ...style.option, backgroundColor: "transparent" }}
            onChange={(e) => (e.target.value.length > maxAnswerChar ? null : handleChange(e))}
            readonly={previewModalOpen ? true : false}
          />
        </div>
      </button>
    );
  if (optionKey === "r_option")
    return (
      <button
        onMouseEnter={() => setHoverRight(true)}
        onMouseLeave={() => setHoverRight(false)}
        className="@button activity_container__mtf_btn"
        style={style ? { ...style.button, ...(hoverRight ? style.optionHover : null) } : {}}
        onClick={handleButtonClick}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            handleTextClick();
          }}
        >
          <EditText
            value={option.r_option}
            className="editable_text"
            style={{ ...style.option, backgroundColor: "transparent" }}
            onChange={(e) => (e.target.value.length > maxAnswerChar ? null : handleChange(e))}
            readonly={previewModalOpen ? true : false}
          />
        </div>
      </button>
    );
}
